import {
  Alert,
  AlertDescription,
  AlertTitle,
  FormControl,
  FormLabel,
  HStack,
  Text,
  Textarea,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Input, Select } from '~/components';
import { InputFloat } from '~/components/InputFloat';

export type RulesTerminationContractsGroupType = {
  aviso_previo_em_meses?: number;
  multa?: number;
  dia_limite_solicitar_rescisao?: number;
};

export const RulesTerminationContractsGroup: React.VFC<{
  obj: RulesTerminationContractsGroupType;
  alteraObj: (obj: RulesTerminationContractsGroupType) => void;
}> = ({ obj, alteraObj }) => {
  const { setError, clearErrors, formState } = useForm();
  const { errors } = formState;
  const inicializador: RulesTerminationContractsGroupType = {
    aviso_previo_em_meses: obj.aviso_previo_em_meses || 0,
    multa: obj.multa || 0,
    dia_limite_solicitar_rescisao: obj.dia_limite_solicitar_rescisao || 0,
  };
  const [objControl, setObj] =
    useState<RulesTerminationContractsGroupType>(inicializador);
  useEffect(() => {
    if (obj) {
      const objeto = {
        aviso_previo_em_meses: obj.aviso_previo_em_meses || 0,
        multa: obj.multa || 0,
        dia_limite_solicitar_rescisao: obj.dia_limite_solicitar_rescisao || 0,
      };
      setObj(objeto);
    }
  }, [obj]);

  const handleAvisoPrevio = (value: string) => {
    clearErrors('aviso_previo');
    const v = value.replace(/\D/g, '');
    if (v.length > 12) {
      return;
    }
    if (!Number(v)) {
      setError('aviso_previo', {
        type: 'required',
        message: 'O valor deve ser maior que 0',
      });
    }
    const objeto = { ...objControl, aviso_previo_em_meses: Number(v) };
    setObj(objeto);
    alteraObj(objeto);
  };

  const handleMulta = (value: number) => {
    clearErrors('multa');
    if (value > 999.99) {
      setError('multa', {
        type: 'maxLength',
        message: 'O valor não pode ter mais de 5 dígitos',
      });
    }
    if (!value) {
      setError('multa', {
        type: 'required',
        message: 'O valor deve ser maior que 0',
      });
    }
    const objeto = { ...objControl, multa: value };
    setObj(objeto);
    alteraObj(objeto);
  };

  const handleDiaLimite = (value: string) => {
    clearErrors('dia_limite_solicitar_rescisao');
    const v = value.replace(/\D/g, '');
    if (Number(v) > 31) {
      return;
    }
    if (!Number(v)) {
      setError('dia_limite_solicitar_rescisao', {
        type: 'required',
        message: 'O valor deve ser maior que 0',
      });
    }
    const objeto = { ...objControl, dia_limite_solicitar_rescisao: Number(v) };
    setObj(objeto);
    alteraObj(objeto);
  };

  return (
    <HStack
      alignItems="baseline"
      w="100%"
      p={5}
      whiteSpace="nowrap"
      flexWrap="wrap"
    >
      <FormControl isInvalid={errors.aviso_previo} minW="325px" maxW="325px">
        <Input
          isRequired
          label="Aviso prévio para solicitação de rescisão (meses)"
          error={errors.aviso_previo}
          type="text"
          size="sm"
          textAlign="left"
          fontSize="15px"
          value={Number(objControl.aviso_previo_em_meses).toLocaleString(
            'pt-BR',
            {
              maximumFractionDigits: 0,
            },
          )}
          name="aviso_previo"
          onChange={e => handleAvisoPrevio(e.target.value)}
        />
      </FormControl>
      <FormControl isInvalid={errors.multa} w="300px">
        <InputFloat
          isRequired
          label="Multa %"
          error={errors.multa}
          type="text"
          size="sm"
          textAlign="left"
          fontSize="15px"
          value={objControl.multa}
          name="multa"
          onChangeValue={e => handleMulta(e)}
        />
      </FormControl>
      <FormControl
        isInvalid={errors.dia_limite_solicitar_rescisao}
        minW="325px"
        maxW="325px"
      >
        <Input
          isRequired
          label="Dia limite para solicitar rescisão no mês corrente"
          error={errors.dia_limite_solicitar_rescisao}
          type="text"
          size="sm"
          textAlign="left"
          fontSize="15px"
          value={Number(
            objControl.dia_limite_solicitar_rescisao,
          ).toLocaleString('pt-BR', {
            maximumFractionDigits: 0,
          })}
          name="dia_limite_solicitar_rescisao"
          onChange={e => handleDiaLimite(e.target.value)}
        />
      </FormControl>
    </HStack>
  );
};
